import React from 'react';
import Card from '../../components/UI/Card';
import { Search } from 'lucide-react';
import useTranslation from '../../hooks/useTranslation';

const DealFinder = () => {
  const { t } = useTranslation();
  return (
    <Card className="p-8 text-center space-y-4">
      <div className="mx-auto w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
        <Search className="h-6 w-6" />
      </div>
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
        {t('dealFinder.comingSoon.title')}
      </h2>
      <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
        {t('dealFinder.comingSoon.description')}
      </p>
      <div className="inline-flex items-center px-4 py-2 rounded-full bg-gray-100 dark:bg-dark-700 text-gray-700 dark:text-gray-200 text-sm font-medium">
        {t('dealFinder.comingSoon.tag')}
      </div>
      <p className="text-xs text-gray-400 max-w-xl mx-auto">
        {t('dealFinder.comingSoon.note')}
      </p>
    </Card>
  );
};

export default DealFinder;
